import { Injectable } from '@angular/core';
import { ErrorObj } from 'src/app/core/models';
import { ErrorService } from 'src/app/core/services/error.service';
import { UserService } from 'src/app/core/user/user.service';

@Injectable({
  providedIn: "root"
})
export class ForgotPasswordService {

  constructor(
    private userService: UserService,
    private errorService: ErrorService,
  ) { }

  async onForgotPassword(mobileNo: string, newPassword: string, otpCode: string) {
    try {
      return await this.userService.forgotPassword(mobileNo, newPassword, otpCode);
    } catch (err) {
      this.setError(err);
    }
  }

  private setError(errorObj: ErrorObj) {
    this.errorService.insertErrorObj(errorObj);
    this.userService.error(errorObj);
  }
}
